import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import omit from 'lodash/omit';
import { MULTIPLE_APPS_CONFLICT, MULTIPLE_APPS_CONFLICT_CAUSE_FIELD, MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS } from '../../../../utils/errors/constants';
import { mapFieldPropertyToApiMethod } from '../../../../utils/map-field-property-to-api-method';
import { SCREEN_TABS_HISTORY_TYPE } from '../../constants';
var MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
var mapToAppErrors = function mapToAppErrors(_ref) {
  var conflicts = _ref.conflicts,
    lifecycleHook = _ref.lifecycleHook;
  var appErrors = conflicts.map(function (change) {
    if (change.type === SCREEN_TABS_HISTORY_TYPE) {
      return {
        type: MULTIPLE_APPS_CONFLICT,
        cause: MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS,
        lifecycleHook: lifecycleHook,
        message: "Your and other app modified screen tabs in the '".concat(lifecycleHook, "' at the same trigger. ").concat(MESSAGE_SUFFIX)
      };
    }
    var fieldId = change.fieldId,
      fieldType = change.fieldType,
      property = change.property;
    var method = mapFieldPropertyToApiMethod(property);
    return {
      type: MULTIPLE_APPS_CONFLICT,
      cause: MULTIPLE_APPS_CONFLICT_CAUSE_FIELD,
      fieldId: fieldId,
      fieldType: fieldType,
      method: method,
      lifecycleHook: lifecycleHook,
      message: "Your and other app modified the same field: '".concat(fieldId, "' by its method: '").concat(method, "' in the '").concat(lifecycleHook, "' at the same trigger. ").concat(MESSAGE_SUFFIX)
    };
  });
  return appErrors;
};
export var collectConflicts = function collectConflicts(_ref2) {
  var appliedChangesHistory = _ref2.appliedChangesHistory,
    newChanges = _ref2.newChanges,
    appIdOfNewChanges = _ref2.appIdOfNewChanges,
    lifecycleHook = _ref2.lifecycleHook;
  return Object.entries(omit(appliedChangesHistory, appIdOfNewChanges)).reduce(function (acc, _ref3) {
    var _acc$conflicts;
    var _ref4 = _slicedToArray(_ref3, 2),
      appId = _ref4[0],
      previousChanges = _ref4[1];
    var previousChangesKeys = Object.keys(previousChanges);

    // Compares previous changes with new changes keys
    var conflicts = Object.entries(newChanges).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        changeKey = _ref6[0],
        _ = _ref6[1];
      return previousChangesKeys.includes(changeKey);
    }).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        _ = _ref8[0],
        change = _ref8[1];
      return _objectSpread(_objectSpread({}, change), {}, {
        lifecycleHook: lifecycleHook,
        appIds: [appId, appIdOfNewChanges]
      });
    });
    (_acc$conflicts = acc.conflicts).push.apply(_acc$conflicts, _toConsumableArray(conflicts));

    // Maps conflicts to app errors
    var appErrors = mapToAppErrors({
      conflicts: conflicts,
      lifecycleHook: lifecycleHook
    });
    if (appErrors.length > 0) {
      var _acc$appErrorsMap$app;
      acc.appErrorsMap[appId] = appErrors;
      // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
      // We need to merge them to avoid overwriting and keep all errors.
      acc.appErrorsMap[appIdOfNewChanges] = [].concat(_toConsumableArray((_acc$appErrorsMap$app = acc.appErrorsMap[appIdOfNewChanges]) !== null && _acc$appErrorsMap$app !== void 0 ? _acc$appErrorsMap$app : []), _toConsumableArray(appErrors));
    }
    return acc;
  }, {
    appErrorsMap: {},
    conflicts: []
  });
};